'use client';
import { useCartContext } from "@/providers/CartContext";
import { useWishlistContext } from "@/providers/WshlistContext";
import {useEffect, useState} from 'react';
import {useTranslations} from 'next-intl';
import {useBaseMutation} from '@/libs/api/baseRequests';
import {UPDATE_CLIENT_CART_SELF_QUERY, UPDATE_CLIENT_WISHLIST_SELF_QUERY} from '@/graphql/account';
import {useUserContext} from '@/providers/UserContext';

export default function ProductDetailsActions({ product }) {
  const t = useTranslations('catalog');
  
  const { user } = useUserContext();
  // const { setCurrentProduct } = useProductContext();
  const { addProductToCart, getProductQuantityFromCart } = useCartContext();
  const { updateWishlist, hasWishlist } = useWishlistContext();
  
  const [submitting, setSubmitting] = useState(false);
  const {mutate: mutateCart} = useBaseMutation(UPDATE_CLIENT_CART_SELF_QUERY, {});
  const {mutate: mutateWishlist} = useBaseMutation(UPDATE_CLIENT_WISHLIST_SELF_QUERY, {});
  
  const isInWishlist = hasWishlist(product);
  const productQuantityCart = getProductQuantityFromCart(product);
  
  const [quantity, setQuantity] = useState(productQuantityCart);
  // todo html to image on share
  
  useEffect(() => {
    setQuantity(productQuantityCart);
  }, [productQuantityCart]);
  
  const onClickAddCart = async () => {
    if (!user) {
      // setCurrentProduct(product);
      addProductToCart(product, quantity, true);
      return;
    }
    
    setSubmitting(true);
    const result = await mutateCart({
      variables: {
        action: 'UPDATE_OR_CREATE',
        productId: product.id,
        quantity,
        staticQuantity: true
      }
    });
    if (result.data) {
      // setCurrentProduct(product);
      addProductToCart(product, quantity, true);
    }
    setSubmitting(false);
  }
  
  const onClickUpdateWishlist = async () => {
    if (!user) {
      updateWishlist(product);
      return;
    }
    
    setSubmitting(true);
    const result = await mutateWishlist({
      variables: {
        liked: !isInWishlist,
        productId: product.id
      }
    });
    if (result.data) {
      updateWishlist(product);
    }
    setSubmitting(false);
  }
  
  return (
      <>
        {
          !!productQuantityCart ? (
              <div className="product-cart-details">
                {t.rich('countItemsInCart', {
                  b: (chunks) => (<b>{chunks}</b>),
                  count: productQuantityCart
                })}
              </div>
          ) : ''
        }
        <div className="ltn__product-details-menu-2">
          <ul>
            <li>
              <div className="cart-plus-minus">
                <div
                    className="dec qtybutton"
                    onClick={() => setQuantity(prevState => prevState <= 1 ? prevState : prevState - 1)}
                >-
                </div>
                <input
                    onChange={(e) => setQuantity(!parseInt(e.target.value) ? 1 : parseInt(e.target.value))}
                    type="text"
                    value={quantity}
                    // name="qtybutton"
                    className="cart-plus-minus-box"
                />
                <div
                    className="inc qtybutton"
                    onClick={() => setQuantity(prevState => prevState + 1)}
                >+
                </div>
              </div>
            </li>
            {' '}
            <li>
              <button
                  onClick={onClickAddCart}
                  className="theme-btn-1 btn btn-effect-1"
                  title={t('cart')}
                  // data-bs-toggle="modal"
                  // data-bs-target="#add_to_cart_modal"
                  disabled={quantity <= 0 || submitting}
              >
                <i className="fas fa-shopping-cart"></i> <span className="text-uppercase">{!!productQuantityCart ? t('updateCart') : t('addToCart')}</span>
              </button>
            </li>
          </ul>
        </div>
        {/* add to wishlist and compare */}
        <div className="ltn__product-details-menu-3">
          <ul>
            <li>
              <button
                  onClick={onClickUpdateWishlist}
                  title={t('wishlist')}
                  disabled={submitting}
              >
                <i className={`fa${isInWishlist ? 's' : 'r'} fa-heart`}></i>{' '}
                <span>{isInWishlist ? t('removeFromWishlist') : t('addToWishlist')}</span>
              </button>
            </li>
          </ul>
        </div>
      </>
  );
};
